import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Layout, Dropdown, Menu, Space, Button, Modal, Select, Typography, message, Row, Col, Card, Upload, Divider } from 'antd';
import { DownOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import fileDownload from 'js-file-download';
import moment from 'moment-timezone';

import DefaultLayout from '../../layouts/DefaultLayout/DefaultLayout';
import { setLoading } from '../../redux/authSlice';
import { $api } from '../../services/service';
import ErrorDialog from '../../components/Elements/ErrorDialog/ErrorDialog';

const { Option } = Select;
const { Title, Text } = Typography;

function MarkBoard() {
    let history = useHistory();
    const dispatch = useDispatch();
    const { fId, cId } = useParams();

    const [classChoose, setClassChoose] = useState('');
    const [faculties, setFaculties] = useState([]);
    const [semesterClass, setSemesterClass] = useState([]);
    const [faculty, setFaculty] = useState('');
    const [errDialog, setErrDialog] = useState({ isOpen: false, subTitle: '' });
    const [modalExport, setModalExport] = useState({ isOpen: false, type: 'all' });
    const [exportParam, setExportParam] = useState({ classId: '', semester: '', year: '' });

    // Tuition fee management states
    const [tuitionFaculties, setTuitionFaculties] = useState([]);
    const [tuitionFacultyId, setTuitionFacultyId] = useState('');
    const [tuitionClasses, setTuitionClasses] = useState([]);
    const [tuitionClassId, setTuitionClassId] = useState('');
    const [importModalVisible, setImportModalVisible] = useState(false);
    const [importFile, setImportFile] = useState(null);
    useEffect(() => {
        async function getFaculties() {
            try {
                dispatch(setLoading(true));
                const res = await $api.faculties.GetAllAndClass();
                if (res && res.result.length > 0) {
                    setFaculties(res.result);
                    setFaculty(fId || res.result[0].id);
                }
            } catch (e) {
                show_ErrMsg('Không tải được danh sách khoa');
            } finally {
                dispatch(setLoading(false));
            }
        }
        getFaculties();
    }, []);

    async function getSemesterByClass() {
        try {
            dispatch(setLoading(true));
            const res = await $api.semesterPlanning.getByClass(cId);
            if (res && res.result.length > 0) {
                setSemesterClass(res.result);
            }
        } catch (e) {
            show_ErrMsg('Không tải được học kỳ');
        } finally {
            dispatch(setLoading(false));
        }
    }

    function getMarkDetails(faculty, classInfo) {
        history.push(`/bang-diem/${faculty.id}/${classInfo.id}`);
        setClassChoose(`Khoa: ${faculty.name} - Lớp: ${classInfo.name}`);
        setExportParam({ ...exportParam, classId: classInfo.id });
        getSemesterByClass();
    }

    function show_ErrMsg(msg) {
        message.error(msg);
        setErrDialog({ isOpen: true, subTitle: msg });
    }

    function closeModal() {
        setModalExport({ isOpen: false, type: 'all' });
        setExportParam({ classId: cId, semester: '', year: '' });
    }

    async function exportData() {
        if (exportParam.classId === '') {
            show_ErrMsg('Vui lòng chọn lớp để xuất dữ liệu!');
            return;
        }

        if (modalExport.type === 'semester' && exportParam.semester === '') {
            show_ErrMsg('Vui lòng chọn học kỳ!');
            return;
        }
        if (modalExport.type === 'year' && exportParam.year === '') {
            show_ErrMsg('Vui lòng chọn năm học!');
            return;
        }

        try {
            dispatch(setLoading(true));
            let params = { classId: exportParam.classId };
            if (modalExport.type === 'semester') {
                params.semester = exportParam.semester;
            }
            if (modalExport.type === 'year') {
                params.year = exportParam.year;
            }
            const res = await $api.exam.examExportWithClassOption(params);
            fileDownload(
                res,
                `Bang-diem-${modalExport.type === 'all'
                    ? 'toan-khoa'
                    : modalExport.type === 'semester'
                        ? 'hoc-ki-' + exportParam.semester
                        : 'nam-' + exportParam.year
                }-${classChoose}-ngay-${moment(new Date()).format('DD-MM-YYYY')}.xlsx`
            );
        } catch (e) {
            show_ErrMsg('Xuất dữ liệu thất bại');
        } finally {
            dispatch(setLoading(false));
            closeModal();
        }
    }

    async function exportSubjectTeachingData() {
        if (exportParam.classId === '') {
            show_ErrMsg('Vui lòng chọn lớp để xuất dữ liệu!');
            return;
        }
        try {
            dispatch(setLoading(true));
            const res = await $api.schedule.exportSubjectTeaching(exportParam.classId);
            fileDownload(
                res,
                `Tien-do-${classChoose}-ngay-${moment(new Date()).format('DD-MM-YYYY')}.xlsx`
            );
        } catch (e) {
            show_ErrMsg('Xuất tiến độ thất bại');
        } finally {
            dispatch(setLoading(false));
        }
    }

    // Tuition Fee Management Functions
    useEffect(() => {
        async function getTuitionFaculties() {
            try {
                dispatch(setLoading(true));
                const res = await $api.faculties.getPaging({});
                if (res && res.result && res.result.items) {
                    setTuitionFaculties(res.result.items);
                }
            } catch (e) {
                show_ErrMsg('Không tải được danh sách khoa');
            } finally {
                dispatch(setLoading(false));
            }
        }
        getTuitionFaculties();
    }, []);

    useEffect(() => {
        async function getTuitionClasses() {
            if (tuitionFacultyId) {
                try {
                    dispatch(setLoading(true));
                    const res = await $api.class.getPaging({ facultyId: tuitionFacultyId });
                    if (res && res.result && res.result.items) {
                        setTuitionClasses(res.result.items);
                    }
                } catch (e) {
                    show_ErrMsg('Không tải được danh sách lớp');
                } finally {
                    dispatch(setLoading(false));
                }
            } else {
                setTuitionClasses([]);
            }
        }
        getTuitionClasses();
    }, [tuitionFacultyId]);

    async function downloadTuitionTemplate() {
        try {
            dispatch(setLoading(true));
            const res = await $api.semesterTuitionService.downloadTemplate();
            fileDownload(
                res,
                `Mau-hoc-phi-${moment(new Date()).format('DD-MM-YYYY')}.xlsx`
            );
            message.success('Tải mẫu học phí thành công');
        } catch (e) {
            show_ErrMsg('Tải mẫu học phí thất bại');
        } finally {
            dispatch(setLoading(false));
        }
    }

    async function handleImportTuition() {
        if (!importFile) {
            show_ErrMsg('Vui lòng chọn file để import');
            return;
        }

        try {
            dispatch(setLoading(true));
            const formData = new FormData();
            formData.append('file', importFile);

            await $api.semesterTuitionService.import(formData);
            message.success('Import học phí thành công');
            setImportModalVisible(false);
            setImportFile(null);
        } catch (e) {
            show_ErrMsg(e?.response?.data?.message || 'Import học phí thất bại');
        } finally {
            dispatch(setLoading(false));
        }
    }

    async function exportTuitionFee() {
        try {
            dispatch(setLoading(true));
            const params: any = {};
            if (tuitionFacultyId) {
                params.facultyId = tuitionFacultyId;
            }
            if (tuitionClassId) {
                params.classId = tuitionClassId;
            }

            const res = await $api.semesterTuitionService.export(params);
            const facultyName = tuitionFacultyId
                ? tuitionFaculties.find((f: any) => f.id === tuitionFacultyId)?.name || 'All'
                : 'All';
            const className = tuitionClassId
                ? tuitionClasses.find((c: any) => c.id === tuitionClassId)?.name || ''
                : '';

            fileDownload(
                res,
                `Hoc-phi-${facultyName}${className ? '-' + className : ''}-${moment(new Date()).format('DD-MM-YYYY')}.xlsx`
            );
            message.success('Xuất học phí thành công');
        } catch (e) {
            show_ErrMsg('Xuất học phí thất bại');
        } finally {
            dispatch(setLoading(false));
        }
    }

    const uploadProps = {
        beforeUpload: (file: any) => {
            setImportFile(file);
            return false;
        },
        onRemove: () => {
            setImportFile(null);
        },
        fileList: importFile ? [importFile] : [] as any,
    };

    const facultyMenu = (
        <Menu>
            {[...faculties]
                .sort((a, b) => a.name.localeCompare(b.name, 'vi'))
                .map((faculty) => (
                    <Menu.SubMenu key={faculty.id} title={faculty.name}>
                        {faculty.classes && faculty.classes.length > 0 ? (
                            faculty.classes.map((cls) => (
                                <Menu.Item key={cls.id} onClick={() => getMarkDetails(faculty, cls)}>
                                    {cls.name}
                                </Menu.Item>
                            ))
                        ) : (
                            <Menu.Item disabled>Không có lớp</Menu.Item>
                        )}
                    </Menu.SubMenu>
                ))}
        </Menu>
    );

    return (
        <DefaultLayout>
            <div className='page__header'>
                <div className='___title flex items-center'>
                    <div className='___title__decorate' />
                    <div className='___title__box'>
                        <div>Bảng điểm tổng hợp</div>
                    </div>
                </div>
            </div>
            <Layout className="mt-3 p-4 bg-white rounded-md shadow-md">
                <Row gutter={[16, 16]} align='middle'>
                    <Col xs={24} md={10}>
                        <Space direction='vertical' style={{ width: '100%' }}>
                            <Text strong>Lớp</Text>
                            <Dropdown overlay={facultyMenu} trigger={['click']}>
                                <Button className='flex justify-between items-center' style={{ minWidth: 200 }}>
                                    {classChoose || 'Chọn lớp'} <DownOutlined />
                                </Button>
                            </Dropdown>
                        </Space>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col span={24}>
                        <div className="flex flex-wrap justify-start md:justify-end gap-2">
                            <Button type='primary' icon={<DownloadOutlined />} onClick={exportSubjectTeachingData}>
                                Xuất tiến độ
                            </Button>
                            <Button type='default' icon={<DownloadOutlined />} onClick={() => setModalExport({ isOpen: true, type: 'semester' })}>
                                Xuất học kỳ
                            </Button>
                            <Button type='dashed' icon={<DownloadOutlined />} onClick={() => setModalExport({ isOpen: true, type: 'year' })}>
                                Xuất năm học
                            </Button>
                            <Button danger icon={<DownloadOutlined />} onClick={() => setModalExport({ isOpen: true, type: 'all' })}>
                                Xuất toàn khóa
                            </Button>
                        </div>
                    </Col>
                </Row>

                <Divider />

                {/* Tuition Fee Management Section */}
                <div className="mt-6">
                    <Title level={4}>Quản lý học phí</Title>

                    <Row gutter={[16, 16]} className="mt-4">
                        <Col span={24}>
                            <Space size="middle">
                                <Button
                                    type="primary"
                                    icon={<DownloadOutlined />}
                                    onClick={downloadTuitionTemplate}
                                >
                                    Tải mẫu học phí
                                </Button>
                                <Button
                                    type="default"
                                    icon={<UploadOutlined />}
                                    onClick={() => setImportModalVisible(true)}
                                >
                                    Import học phí
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]} className="mt-4">
                        <Col xs={24} md={12}>
                            <Card title="Xuất học phí" size="small">
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <div>
                                        <Text strong>Khoa:</Text>
                                        <Select
                                            placeholder="Chọn khoa (có thể bỏ qua)"
                                            style={{ width: '100%', marginTop: 8 }}
                                            value={tuitionFacultyId || undefined}
                                            onChange={(val) => {
                                                setTuitionFacultyId(val);
                                                setTuitionClassId('');
                                            }}
                                            allowClear
                                        >
                                            {tuitionFaculties.map((fac: any) => (
                                                <Option key={fac.id} value={fac.id}>
                                                    {fac.name} ({fac.code})
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>

                                    <div>
                                        <Text strong>Lớp:</Text>
                                        <Select
                                            placeholder="Chọn lớp (có thể bỏ qua)"
                                            style={{ width: '100%', marginTop: 8 }}
                                            value={tuitionClassId || undefined}
                                            onChange={(val) => setTuitionClassId(val)}
                                            disabled={!tuitionFacultyId}
                                            allowClear
                                        >
                                            {tuitionClasses.map((cls: any) => (
                                                <Option key={cls.id} value={cls.id}>
                                                    {cls.name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>

                                    <Button
                                        type="primary"
                                        icon={<DownloadOutlined />}
                                        onClick={exportTuitionFee}
                                        block
                                    >
                                        Xuất học phí
                                    </Button>
                                </Space>
                            </Card>
                        </Col>
                    </Row>
                </div>

                {/* Import Modal */}
                <Modal
                    title="Import học phí"
                    open={importModalVisible}
                    onOk={handleImportTuition}
                    onCancel={() => {
                        setImportModalVisible(false);
                        setImportFile(null);
                    }}
                    okText="Import"
                    cancelText="Hủy"
                >
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Text>Chọn file Excel để import học phí:</Text>
                        <Upload {...uploadProps} accept=".xlsx,.xls">
                            <Button icon={<UploadOutlined />}>Chọn file</Button>
                        </Upload>
                    </Space>
                </Modal>

                <Modal
                    open={modalExport.isOpen}
                    onCancel={closeModal}
                    onOk={exportData}
                    title={`Xuất bảng điểm ${modalExport.type === 'all' ? 'toàn khóa' : 'học kỳ'}`}
                    okText="Xuất"
                    cancelText="Hủy"
                >
                    {modalExport.type === 'semester' && (
                        <div className="mt-2">
                            <Select
                                value={exportParam.semester}
                                style={{ minWidth: 150 }}
                                onChange={(val) => setExportParam({ ...exportParam, semester: val })}
                            >
                                <Option value="">Chọn học kỳ</Option>
                                {semesterClass.map((record) => (
                                    <Option key={record.id} value={record.semester}>
                                        Học kỳ: {record.semester}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    )}

                    {modalExport.type === 'year' && (
                        <div className="mt-2">
                            <Select
                                value={exportParam.year}
                                style={{ minWidth: 150 }}
                                onChange={(val) => setExportParam({ ...exportParam, year: val })}
                            >
                                <Option value="">Chọn năm học</Option>
                                <Option value="1">Năm 1</Option>
                                <Option value="2">Năm 2</Option>
                                <Option value="3">Năm 3</Option>
                                <Option value="4">Năm 4</Option>
                            </Select>
                        </div>
                    )}
                </Modal>

                <ErrorDialog errorDialog={errDialog} setErrorDialog={setErrDialog} />
            </Layout>
        </DefaultLayout>
    );
}

export default MarkBoard;
